/** @jsxImportSource @emotion/react */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { jsx, css } from '@emotion/react'
import { FormikDropdownField } from '../../components/form/Dropdown'
import { default_theme as theme } from '../../emotion/theme'
import { head, get, map, keys, split, size } from 'lodash'
import { adminFaxCostStructureList } from '../actions/admin_fax_cost_structure'
import { CardHeader } from '../../components/layout/CardHeader'
import { adminFaxCostStructureVariantList } from '../actions/admin_fax_cost_structure_variant'
import { LanguageFlag } from '../../components/LanguageFlag'
import { FormikCheckboxField } from '../../components/form/CheckboxField'
import { Separator } from '../../components/layout/Separator'
import { Formik, Form, FieldArray, Field } from 'formik'
import Loading from '../../components/Loading'
import { FormikTextarea } from '../../components/form/TextareaField'
import { FormikInputField } from '../../components/form/InputField'
import AdminMainLayout from './AdminMainLayout'
import BusyMask from '../../components/BusyMask'
import Timestamp from '../../components/Timestamp'
import Card from '../../components/layout/Card'
import { Col, Row, Container, Navbar, Nav } from 'react-bootstrap'
import { Form as BootstrapForm } from 'react-bootstrap'
import * as Yup from 'yup'
import {showSuccess, showError} from '../../actions/Error'
import Button from 'react-bootstrap/Button'
import CardInfoText from '../../components/layout/CardInfoText'
import { BlueButton } from '../../components/layout/BlueButton'
import { FormikGeneralFormErrors } from '../../components/form/GeneralFormErrors'
import { handleSubmitResult } from '../../actions/form'

const validationSchema = Yup.object().shape({
    destination_phone_number_prefix: Yup.string().required("Required"),
    cost_per_page_excluding_vat_euros: Yup.number().required("Required").typeError("Must be a decimal Euros amount"),
    variant: Yup.string().required("Required"), 
})

class AdminFaxCostStructure extends Component {

    componentDidMount() {
        const { dispatch, fax_cost_structure_id } = this.props
        dispatch(adminFaxCostStructureList.ensureObjectLoaded(fax_cost_structure_id))
        dispatch(adminFaxCostStructureVariantList.fetchListIfNeeded())
    }

    componentDidUpdate(prev_props) {
        const { dispatch, fax_cost_structure_id } = this.props
        dispatch(adminFaxCostStructureList.ensureObjectLoaded(fax_cost_structure_id))
    }

    onSave = (values, formik_funcs) => {
        const { history, onSubmit, dispatch, fax_cost_structure_id } = this.props

        const on_ok = function(json) {
            dispatch(adminFaxCostStructureList.invalidateList())
            showSuccess("Saved", "Fax cost saved")

            if ( ! fax_cost_structure_id ) {
                history.push(`/admin/fax_cost_structure/${json.id}`)
            }
        }
        if ( fax_cost_structure_id ) {
            values.id = fax_cost_structure_id
            return dispatch(adminFaxCostStructureList.saveObject(values)).then((res) => handleSubmitResult({res, formik_funcs, on_ok}))
        } else {
            return dispatch(adminFaxCostStructureList.saveNewObject(values)).then((res) => handleSubmitResult({res, formik_funcs, on_ok}))
        }
    }
    
    getCellValue = (header_key, item, index) => {
        switch( header_key ) {
            default:
                return undefined
        }
    }

    renderForm(formik_props) {

        const { fax_cost_structure_variant_options } = this.props

        return (
            <div>
              <Row>
                <Col>

                  <BootstrapForm.Group>
                    <BootstrapForm.Label>Variant</BootstrapForm.Label>
                    <FormikDropdownField name="variant"
                                         formik_props={formik_props}
                                         options={fax_cost_structure_variant_options}
                                         empty_selection_label="Any variant"
                                         placeholder="Variant" />
                  </BootstrapForm.Group>
                  
                  <BootstrapForm.Group>
                    <BootstrapForm.Label>Destination phone number prefix</BootstrapForm.Label>
                    <FormikInputField name="destination_phone_number_prefix" placeholder="Destination phone number prefix" />
                  </BootstrapForm.Group>

                  <BootstrapForm.Group>
                    <BootstrapForm.Label>Cost per page (euros exVAT))</BootstrapForm.Label>
                    <FormikInputField name="cost_per_page_excluding_vat_euros" placeholder="Cost euros" />
                  </BootstrapForm.Group>
                  
                </Col>
              </Row>
              <Row>
                <Col>
                  <BlueButton type="submit">Save</BlueButton>
                </Col>
              </Row>
            </div>
        )
    }

    render() {
        const { initial_values, is_loading, is_busy, fax_cost_structure, fax_cost_structure_id } = this.props
        const that = this
        const title = `${get(fax_cost_structure, ["destination_phone_number_prefix"], 'New fax cost structure')}`

        return (
            <AdminMainLayout breadcrumbs={[{name: 'admin_home'},
                                           
                                           {name: 'fax_cost_structures',
                                            label: 'Fax cost structures',
                                            url: '/admin/fax_cost_structures'},
                                           
                                           {name: 'fax_cost_structure',
                                            label: (
                                                <div css={breadcrumb_item}>
                                                  {get(fax_cost_structure, ["name"], 'New fax cost')}
                                                </div>
                                            ),
                                            url: `/admin/fax_cost_structure/${fax_cost_structure_id}`
                                           }
            ]}>
              <Container fluid>
                { is_busy && <BusyMask /> }
                { is_loading && <Loading /> }

                <CardHeader title={title} />
                <Separator variant="h30" />
                
                { ! is_loading && 
                  <Formik
                      initialValues={initial_values}
                      onSubmit={that.onSave}
                      enableReinitialize={true}
                      validationSchema={validationSchema}
                      >
                    {formik_props => {
                         const { values } = formik_props
                         return (
                             <Form>
                               <FormikGeneralFormErrors render={(msg) => <Row><Col>{msg}</Col></Row>} />
                               <Row>
                                 <Col>
                                   <Card>
                                     { that.renderForm(formik_props) }
                                   </Card>
                                 </Col>
                               </Row>
                             </Form>
                         )}
                    }
                  </Formik>
                }
              </Container>
            </AdminMainLayout>
        )
    }
    
}

function mapStateToProps(state, props) {
    const fax_cost_structure_id = get(props, ["match", "params", "fax_cost_structure_id"], null)
    const fax_cost_structure = adminFaxCostStructureList.getObject(fax_cost_structure_id)
    return {
        fax_cost_structure_id,
        fax_cost_structure,
        is_loading: adminFaxCostStructureList.isLoading(),
        is_busy: adminFaxCostStructureList.getIsSavingObject(),
        initial_values: fax_cost_structure,
        fax_cost_structure_variant_options: adminFaxCostStructureVariantList.getAsOptions()
    }
}

export default connect(mapStateToProps)(AdminFaxCostStructure)

const breadcrumb_item = css`
display: flex;
align-items: center;
`
